var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content  mailing-address" },
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            id: "app",
            visible: _vm.innerVisible,
            "close-on-click-modal": false,
            title: _vm.dialogTitle,
            width: "1500px",
            "append-to-body": "",
            top: "15vh",
            "can-maximize": true
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            },
            close: _vm.handleClose
          }
        },
        [
          _c("el-scrollbar", { staticStyle: { height: "450px" } }, [
            _c(
              "div",
              { staticClass: "app-main-inner-row" },
              [
                _c(
                  "el-form",
                  {
                    ref: "mailingAddressAddForm",
                    attrs: {
                      model: _vm.mailingAddressForm,
                      inline: true,
                      "label-width": "100px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "el-form-item-wrapper" },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("baseInfo.mailingAddress.lobType")
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "170px" },
                                attrs: {
                                  placeholder: _vm.$t(
                                    "common.tips.pleaseChoose"
                                  ),
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.mailingAddressForm.lob,
                                  callback: function($$v) {
                                    _vm.$set(_vm.mailingAddressForm, "lob", $$v)
                                  },
                                  expression: "mailingAddressForm.lob"
                                }
                              },
                              _vm._l(_vm.itemTypeArray, function(item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: { label: item.name, value: item.value }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("baseInfo.mailingAddress.partner1")
                            }
                          },
                          [
                            _c("cargo-advance-select", {
                              staticStyle: { width: "170px" },
                              attrs: {
                                "select-type":
                                  _vm.selectTypeNames.basic_data_Company,
                                filterable: "",
                                "callback-params": { key: "partnerId" },
                                "callback-method-type": "value",
                                "default-value":
                                  _vm.mailingAddressForm.partnerId || ""
                              },
                              on: {
                                parentCallBack: function($event) {
                                  return _vm.getValueFromChild(
                                    _vm.mailingAddressForm,
                                    $event
                                  )
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("baseInfo.mailingAddress.pod1")
                            }
                          },
                          [
                            ["AE", "AI"].indexOf(_vm.mailingAddressForm.lob) !==
                            -1
                              ? _c("cargo-advance-select", {
                                  key: 2,
                                  staticStyle: { width: "170px" },
                                  attrs: {
                                    filterable: "",
                                    "select-type":
                                      _vm.selectTypeNames.basic_data_Airport,
                                    "callback-params": { key: "pod" },
                                    "callback-method-type": "value",
                                    "default-value": _vm.mailingAddressForm.pod
                                  },
                                  on: {
                                    parentCallBack: function($event) {
                                      return _vm.getValueFromChild(
                                        _vm.mailingAddressForm,
                                        $event
                                      )
                                    }
                                  }
                                })
                              : _c("cargo-advance-select", {
                                  key: 1,
                                  staticStyle: { width: "170px" },
                                  attrs: {
                                    "select-type":
                                      _vm.selectTypeNames.basic_data_Seaport,
                                    filterable: "",
                                    "callback-params": { key: "pod" },
                                    "callback-method-type": "value",
                                    "default-value": _vm.mailingAddressForm.pod
                                  },
                                  on: {
                                    parentCallBack: function($event) {
                                      return _vm.getValueFromChild(
                                        _vm.mailingAddressForm,
                                        $event
                                      )
                                    }
                                  }
                                })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("SeaExport.Sales") } },
                          [
                            _c("cargo-user-select", {
                              ref: "sales",
                              staticStyle: { flex: "1" },
                              attrs: {
                                "method-params": {
                                  officeId: _vm.$store.getters.currentOfficeId,
                                  category: "role",
                                  shape: "sales"
                                },
                                "default-value":
                                  _vm.mailingAddressForm.salesId || "",
                                "merge-load": true
                              },
                              on: {
                                change: function(p) {
                                  _vm.mailingAddressForm.salesId = p.value
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "baseInfo.mailingAddress.shipperCode"
                              ),
                              prop: "shipperCode"
                            }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "170px" },
                              model: {
                                value: _vm.mailingAddressForm.shipperCode,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.mailingAddressForm,
                                    "shipperCode",
                                    $$v
                                  )
                                },
                                expression: "mailingAddressForm.shipperCode"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "baseInfo.mailingAddress.consigneeCode"
                              ),
                              prop: "consigneeCode"
                            }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "170px" },
                              model: {
                                value: _vm.mailingAddressForm.consigneeCode,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.mailingAddressForm,
                                    "consigneeCode",
                                    $$v
                                  )
                                },
                                expression: "mailingAddressForm.consigneeCode"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "baseInfo.mailingAddress.notifyCode"
                              ),
                              prop: "notifyCode"
                            }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "170px" },
                              model: {
                                value: _vm.mailingAddressForm.notifyCode,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.mailingAddressForm,
                                    "notifyCode",
                                    $$v
                                  )
                                },
                                expression: "mailingAddressForm.notifyCode"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_PaymentCode"),
                              prop: "paymentCode"
                            }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "170px" },
                              model: {
                                value: _vm.mailingAddressForm.paymentCode,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.mailingAddressForm,
                                    "paymentCode",
                                    $$v
                                  )
                                },
                                expression: "mailingAddressForm.paymentCode"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "app-main-inner-row" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "mini" },
                    on: {
                      click: function($event) {
                        _vm.formatManifestInfo = !_vm.formatManifestInfo
                      }
                    }
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("baseInfo.mailingAddress.formatManifestInfo")
                        ) +
                        " "
                    ),
                    _c("i", {
                      staticClass: "el-icon-caret-bottom el-icon--right"
                    })
                  ]
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "app-main-inner-row" },
              [
                _c(
                  "el-form",
                  {
                    staticStyle: { height: "300px", "min-height": "300px" },
                    attrs: {
                      inline: true,
                      "label-width": "130px",
                      "label-position": "left"
                    },
                    model: {
                      value: _vm.mailingAddressForm,
                      callback: function($$v) {
                        _vm.mailingAddressForm = $$v
                      },
                      expression: "mailingAddressForm"
                    }
                  },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-tag",
                              {
                                staticClass: "tag-w",
                                attrs: { size: "medium" }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("baseInfo.mailingAddress.shipper")
                                  )
                                )
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "el-form-item-wrapper el-form-item-group"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !_vm.formatManifestInfo,
                                        expression: "!formatManifestInfo"
                                      }
                                    ],
                                    style: {
                                      position: "relative",
                                      height: _vm.$selectByLang(
                                        "750px",
                                        "750px",
                                        "750px",
                                        "950px",
                                        "1000px",
                                        "950px"
                                      )
                                    }
                                  },
                                  [
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("line-label", {
                                          attrs: {
                                            slot: "label",
                                            label: _vm.$t(
                                              "baseInfo.mailingAddress.shipperEnterpriseCode"
                                            )
                                          },
                                          slot: "label"
                                        }),
                                        _c("cargo-input", {
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify,
                                            placeholder: _vm.$t(
                                              "baseInfo.mailingAddress.shortCode"
                                            )
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .shipperShortCode,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "shipperShortCode",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.shipperShortCode"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: " " } },
                                      [
                                        _c("cargo-input", {
                                          staticClass: "prefix-input",
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify,
                                            placeholder: _vm.$t(
                                              "baseInfo.mailingAddress.enterpriseCode"
                                            )
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .shipperEnterpriseCode,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "shipperEnterpriseCode",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.shipperEnterpriseCode"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("line-label", {
                                          attrs: {
                                            slot: "label",
                                            label: _vm.$t(
                                              "baseInfo.mailingAddress.shipperEnterpriseName"
                                            )
                                          },
                                          slot: "label"
                                        }),
                                        _c("cargo-input", {
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .shipperEnterpriseName,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "shipperEnterpriseName",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.shipperEnterpriseName"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "baseInfo.mailingAddress.shipperAddress"
                                          )
                                        }
                                      },
                                      [
                                        _c("cargo-input", {
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .shipperAddress,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "shipperAddress",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.shipperAddress"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            staticStyle: { width: "130px" },
                                            model: {
                                              value:
                                                _vm.mailingAddressForm
                                                  .shipperContactsType,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.mailingAddressForm,
                                                  "shipperContactsType",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "mailingAddressForm.shipperContactsType"
                                            }
                                          },
                                          _vm._l(
                                            _vm.contactType
                                              .shipperContactsTypes,
                                            function(item) {
                                              return _c("el-option", {
                                                key: item.value,
                                                attrs: {
                                                  label: item.label,
                                                  value: item.value
                                                }
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                        _c("cargo-input", {
                                          staticStyle: { width: "135px" },
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .shipperContacts,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "shipperContacts",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.shipperContacts"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "baseInfo.mailingAddress.cityName"
                                          )
                                        }
                                      },
                                      [
                                        _c("cargo-input", {
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .shipperCityName,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "shipperCityName",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.shipperCityName"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "baseInfo.mailingAddress.provinceCode"
                                          )
                                        }
                                      },
                                      [
                                        _c("cargo-input", {
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .shipperProvinceCode,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "shipperProvinceCode",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.shipperProvinceCode"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "baseInfo.mailingAddress.provinceName"
                                          )
                                        }
                                      },
                                      [
                                        _c("cargo-input", {
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .shipperProvinceName,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "shipperProvinceName",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.shipperProvinceName"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "baseInfo.mailingAddress.zipCode"
                                          )
                                        }
                                      },
                                      [
                                        _c("cargo-input", {
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .shipperZipCode,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "shipperZipCode",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.shipperZipCode"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "CargoMsg.Cargo_CountryRegionCode"
                                          )
                                        }
                                      },
                                      [
                                        _c("cargo-input", {
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .shipperCountryCode,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "shipperCountryCode",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.shipperCountryCode"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "baseInfo.mailingAddress.aeoEnterpriseCode"
                                          )
                                        }
                                      },
                                      [
                                        _c("cargo-input", {
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .shipperAeoEnterpriseCode,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "shipperAeoEnterpriseCode",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.shipperAeoEnterpriseCode"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "EORI" } },
                                      [
                                        _c("cargo-input", {
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .shipperEori,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "shipperEori",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.shipperEori"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "SeaExport.StreetNumber"
                                          )
                                        }
                                      },
                                      [
                                        _c("cargo-input", {
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .shipperStreetNo,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "shipperStreetNo",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.shipperStreetNo"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "VIP CODE" } },
                                      [
                                        _c("cargo-input", {
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .shipperVipCode,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "shipperVipCode",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.shipperVipCode"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "MSC CODE" } },
                                      [
                                        _c("cargo-input", {
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .shipperMscCode,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "shipperMscCode",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.shipperMscCode"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "COMPANY CODE" } },
                                      [
                                        _c("cargo-input", {
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .shipperCompanyCode,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "shipperCompanyCode",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.shipperCompanyCode"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "INTTRA CODE" } },
                                      [
                                        _c("cargo-input", {
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .shipperInttraCode,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "shipperInttraCode",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.shipperInttraCode"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "float-btn-wrapper" },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: { type: "info" },
                                            on: {
                                              click: function($event) {
                                                return _vm.syncFormatInfoToOrder(
                                                  "shipper"
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "baseInfo.mailingAddress.syncFormatInfoToOrder"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "el-form-item-wrapper" },
                                  [
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("cargo-input", {
                                          staticClass: "input-w",
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          nativeOn: {
                                            dblclick: function($event) {
                                              return _vm.popRowDataEditor(
                                                "shipper"
                                              )
                                            }
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .shipperLine1,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "shipperLine1",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.shipperLine1"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("cargo-input", {
                                          staticClass: "input-w",
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          nativeOn: {
                                            dblclick: function($event) {
                                              return _vm.popRowDataEditor(
                                                "shipper"
                                              )
                                            }
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .shipperLine2,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "shipperLine2",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.shipperLine2"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("cargo-input", {
                                          staticClass: "input-w",
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          nativeOn: {
                                            dblclick: function($event) {
                                              return _vm.popRowDataEditor(
                                                "shipper"
                                              )
                                            }
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .shipperLine3,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "shipperLine3",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.shipperLine3"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("cargo-input", {
                                          staticClass: "input-w",
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          nativeOn: {
                                            dblclick: function($event) {
                                              return _vm.popRowDataEditor(
                                                "shipper"
                                              )
                                            }
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .shipperLine4,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "shipperLine4",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.shipperLine4"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("cargo-input", {
                                          staticClass: "input-w",
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          nativeOn: {
                                            dblclick: function($event) {
                                              return _vm.popRowDataEditor(
                                                "shipper"
                                              )
                                            }
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .shipperLine5,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "shipperLine5",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.shipperLine5"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("cargo-input", {
                                          staticClass: "input-w",
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          nativeOn: {
                                            dblclick: function($event) {
                                              return _vm.popRowDataEditor(
                                                "shipper"
                                              )
                                            }
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .shipperLine6,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "shipperLine6",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.shipperLine6"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-tag",
                              {
                                staticClass: "tag-w",
                                attrs: { size: "medium" }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("baseInfo.mailingAddress.consignee")
                                  )
                                )
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "el-form-item-wrapper el-form-item-group"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !_vm.formatManifestInfo,
                                        expression: "!formatManifestInfo"
                                      }
                                    ],
                                    style: {
                                      position: "relative",
                                      height: _vm.$selectByLang(
                                        "750px",
                                        "750px",
                                        "750px",
                                        "950px",
                                        "1000px",
                                        "950px"
                                      )
                                    }
                                  },
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: " " } },
                                      [
                                        _c("el-checkbox", {
                                          attrs: {
                                            label: _vm.$t(
                                              "baseInfo.mailingAddress.instructBill"
                                            )
                                          },
                                          on: { change: _vm.ladingBill },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .instructBill,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "instructBill",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.instructBill"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("line-label", {
                                          attrs: {
                                            slot: "label",
                                            label: _vm.$t(
                                              "baseInfo.mailingAddress.consigneeEnterpriseCode"
                                            )
                                          },
                                          slot: "label"
                                        }),
                                        _c("cargo-input", {
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify,
                                            placeholder: _vm.$t(
                                              "baseInfo.mailingAddress.shortCode"
                                            )
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .consigneeShortCode,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "consigneeShortCode",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.consigneeShortCode"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: " " } },
                                      [
                                        _c("cargo-input", {
                                          staticClass: "prefix-input",
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify,
                                            placeholder: _vm.$t(
                                              "baseInfo.mailingAddress.enterpriseCode"
                                            )
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .consigneeEnterpriseCode,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "consigneeEnterpriseCode",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.consigneeEnterpriseCode"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("line-label", {
                                          attrs: {
                                            slot: "label",
                                            label: _vm.$t(
                                              "baseInfo.mailingAddress.consigneeEnterpriseName"
                                            )
                                          },
                                          slot: "label"
                                        }),
                                        _c("cargo-input", {
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .consigneeEnterpriseName,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "consigneeEnterpriseName",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.consigneeEnterpriseName"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "baseInfo.mailingAddress.consigneeAddress"
                                          )
                                        }
                                      },
                                      [
                                        _c("cargo-input", {
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .consigneeAddress,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "consigneeAddress",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.consigneeAddress"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            staticStyle: { width: "130px" },
                                            model: {
                                              value:
                                                _vm.mailingAddressForm
                                                  .consigneeContactsType,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.mailingAddressForm,
                                                  "consigneeContactsType",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "mailingAddressForm.consigneeContactsType"
                                            }
                                          },
                                          _vm._l(
                                            _vm.contactType
                                              .consigneeContactsTypes,
                                            function(item) {
                                              return _c("el-option", {
                                                key: item.value,
                                                attrs: {
                                                  label: item.label,
                                                  value: item.value
                                                }
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                        _c("cargo-input", {
                                          staticStyle: { width: "135px" },
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .consigneeContacts,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "consigneeContacts",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.consigneeContacts"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "baseInfo.mailingAddress.cityName"
                                          )
                                        }
                                      },
                                      [
                                        _c("cargo-input", {
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .consigneeCityName,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "consigneeCityName",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.consigneeCityName"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "baseInfo.mailingAddress.provinceCode"
                                          )
                                        }
                                      },
                                      [
                                        _c("cargo-input", {
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .consigneeProvinceCode,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "consigneeProvinceCode",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.consigneeProvinceCode"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "baseInfo.mailingAddress.provinceName"
                                          )
                                        }
                                      },
                                      [
                                        _c("cargo-input", {
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .consigneeProvinceName,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "consigneeProvinceName",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.consigneeProvinceName"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "baseInfo.mailingAddress.zipCode"
                                          )
                                        }
                                      },
                                      [
                                        _c("cargo-input", {
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .consigneeZipCode,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "consigneeZipCode",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.consigneeZipCode"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "CargoMsg.Cargo_CountryRegionCode"
                                          )
                                        }
                                      },
                                      [
                                        _c("cargo-input", {
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .consigneeCountryCode,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "consigneeCountryCode",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.consigneeCountryCode"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "baseInfo.mailingAddress.aeoEnterpriseCode"
                                          )
                                        }
                                      },
                                      [
                                        _c("cargo-input", {
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .consigneeAeoEnterpriseCode,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "consigneeAeoEnterpriseCode",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.consigneeAeoEnterpriseCode"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("line-label", {
                                          attrs: {
                                            slot: "label",
                                            label: _vm.$t(
                                              "baseInfo.mailingAddress.consigneeSpecificContactsName"
                                            )
                                          },
                                          slot: "label"
                                        }),
                                        _c("cargo-input", {
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .consigneeSpecificContactsName,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "consigneeSpecificContactsName",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.consigneeSpecificContactsName"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "EORI" } },
                                      [
                                        _c("cargo-input", {
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .consigneeEori,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "consigneeEori",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.consigneeEori"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "SeaExport.StreetNumber"
                                          )
                                        }
                                      },
                                      [
                                        _c("cargo-input", {
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .consigneeStreetNo,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "consigneeStreetNo",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.consigneeStreetNo"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "VIP CODE" } },
                                      [
                                        _c("cargo-input", {
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .consigneeVipCode,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "consigneeVipCode",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.consigneeVipCode"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "MSC CODE" } },
                                      [
                                        _c("cargo-input", {
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .consigneeMscCode,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "consigneeMscCode",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.consigneeMscCode"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "COMPANY CODE" } },
                                      [
                                        _c("cargo-input", {
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .consigneeCompanyCode,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "consigneeCompanyCode",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.consigneeCompanyCode"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "INTTRA CODE" } },
                                      [
                                        _c("cargo-input", {
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .consigneeInttraCode,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "consigneeInttraCode",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.consigneeInttraCode"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            staticStyle: { width: "130px" },
                                            model: {
                                              value:
                                                _vm.mailingAddressForm
                                                  .consigneeSpecificContactsType,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.mailingAddressForm,
                                                  "consigneeSpecificContactsType",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "mailingAddressForm.consigneeSpecificContactsType"
                                            }
                                          },
                                          _vm._l(
                                            _vm.contactType
                                              .consigneeSpecificContactsTypes,
                                            function(item) {
                                              return _c("el-option", {
                                                key: item.value,
                                                attrs: {
                                                  label: item.label,
                                                  value: item.value
                                                }
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                        _c("cargo-input", {
                                          staticStyle: { width: "135px" },
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .consigneeSpecificContacts,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "consigneeSpecificContacts",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.consigneeSpecificContacts"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "float-btn-wrapper" },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: { type: "info" },
                                            on: {
                                              click: function($event) {
                                                return _vm.syncFormatInfoToOrder(
                                                  "consignee"
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "baseInfo.mailingAddress.syncFormatInfoToOrder"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "el-form-item-wrapper" },
                                  [
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("cargo-input", {
                                          staticClass: "input-w",
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          nativeOn: {
                                            dblclick: function($event) {
                                              return _vm.popRowDataEditor(
                                                "consignee"
                                              )
                                            }
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .consigneeLine1,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "consigneeLine1",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.consigneeLine1"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("cargo-input", {
                                          staticClass: "input-w",
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          nativeOn: {
                                            dblclick: function($event) {
                                              return _vm.popRowDataEditor(
                                                "consignee"
                                              )
                                            }
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .consigneeLine2,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "consigneeLine2",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.consigneeLine2"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("cargo-input", {
                                          staticClass: "input-w",
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          nativeOn: {
                                            dblclick: function($event) {
                                              return _vm.popRowDataEditor(
                                                "consignee"
                                              )
                                            }
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .consigneeLine3,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "consigneeLine3",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.consigneeLine3"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("cargo-input", {
                                          staticClass: "input-w",
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          nativeOn: {
                                            dblclick: function($event) {
                                              return _vm.popRowDataEditor(
                                                "consignee"
                                              )
                                            }
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .consigneeLine4,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "consigneeLine4",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.consigneeLine4"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("cargo-input", {
                                          staticClass: "input-w",
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          nativeOn: {
                                            dblclick: function($event) {
                                              return _vm.popRowDataEditor(
                                                "consignee"
                                              )
                                            }
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .consigneeLine5,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "consigneeLine5",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.consigneeLine5"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("cargo-input", {
                                          staticClass: "input-w",
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          nativeOn: {
                                            dblclick: function($event) {
                                              return _vm.popRowDataEditor(
                                                "consignee"
                                              )
                                            }
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .consigneeLine6,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "consigneeLine6",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.consigneeLine6"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-tag",
                              {
                                staticClass: "tag-w",
                                attrs: { size: "medium" }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("baseInfo.mailingAddress.notify")
                                  )
                                )
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "el-form-item-wrapper el-form-item-group"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !_vm.formatManifestInfo,
                                        expression: "!formatManifestInfo"
                                      }
                                    ],
                                    style: {
                                      position: "relative",
                                      height: _vm.$selectByLang(
                                        "750px",
                                        "750px",
                                        "750px",
                                        "950px",
                                        "1000px",
                                        "950px"
                                      )
                                    }
                                  },
                                  [
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("line-label", {
                                          attrs: {
                                            slot: "label",
                                            label: _vm.$t(
                                              "baseInfo.mailingAddress.notifyEnterpriseCode"
                                            )
                                          },
                                          slot: "label"
                                        }),
                                        _c("cargo-input", {
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify,
                                            placeholder: _vm.$t(
                                              "baseInfo.mailingAddress.shortCode"
                                            )
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .notifyShortCode,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "notifyShortCode",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.notifyShortCode"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: " " } },
                                      [
                                        _c("cargo-input", {
                                          staticClass: "prefix-input",
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify,
                                            placeholder: _vm.$t(
                                              "baseInfo.mailingAddress.enterpriseCode"
                                            )
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .notifyEnterpriseCode,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "notifyEnterpriseCode",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.notifyEnterpriseCode"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("line-label", {
                                          attrs: {
                                            slot: "label",
                                            label: _vm.$t(
                                              "baseInfo.mailingAddress.notifyEnterpriseName"
                                            )
                                          },
                                          slot: "label"
                                        }),
                                        _c("cargo-input", {
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .notifyEnterpriseName,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "notifyEnterpriseName",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.notifyEnterpriseName"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "baseInfo.mailingAddress.notifyAddress"
                                          )
                                        }
                                      },
                                      [
                                        _c("cargo-input", {
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .notifyAddress,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "notifyAddress",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.notifyAddress"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            staticStyle: { width: "130px" },
                                            model: {
                                              value:
                                                _vm.mailingAddressForm
                                                  .notifyContactsType,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.mailingAddressForm,
                                                  "notifyContactsType",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "mailingAddressForm.notifyContactsType"
                                            }
                                          },
                                          _vm._l(
                                            _vm.contactType.notifyContactsTypes,
                                            function(item) {
                                              return _c("el-option", {
                                                key: item.value,
                                                attrs: {
                                                  label: item.label,
                                                  value: item.value
                                                }
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                        _c("cargo-input", {
                                          staticStyle: { width: "135px" },
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .notifyContacts,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "notifyContacts",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.notifyContacts"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "baseInfo.mailingAddress.cityName"
                                          )
                                        }
                                      },
                                      [
                                        _c("cargo-input", {
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .notifyCityName,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "notifyCityName",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.notifyCityName"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "baseInfo.mailingAddress.provinceCode"
                                          )
                                        }
                                      },
                                      [
                                        _c("cargo-input", {
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .notifyProvinceCode,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "notifyProvinceCode",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.notifyProvinceCode"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "baseInfo.mailingAddress.provinceName"
                                          )
                                        }
                                      },
                                      [
                                        _c("cargo-input", {
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .notifyProvinceName,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "notifyProvinceName",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.notifyProvinceName"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "baseInfo.mailingAddress.zipCode"
                                          )
                                        }
                                      },
                                      [
                                        _c("cargo-input", {
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .notifyZipCode,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "notifyZipCode",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.notifyZipCode"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "CargoMsg.Cargo_CountryRegionCode"
                                          )
                                        }
                                      },
                                      [
                                        _c("cargo-input", {
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .notifyCountryCode,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "notifyCountryCode",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.notifyCountryCode"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "baseInfo.mailingAddress.aeoEnterpriseCode"
                                          )
                                        }
                                      },
                                      [
                                        _c("cargo-input", {
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .notifyAeoEnterpriseCode,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "notifyAeoEnterpriseCode",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.notifyAeoEnterpriseCode"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "float-btn-wrapper" },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: { type: "info" },
                                            on: {
                                              click: function($event) {
                                                return _vm.syncFormatInfoToOrder(
                                                  "notify"
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "baseInfo.mailingAddress.syncFormatInfoToOrder"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "EORI" } },
                                      [
                                        _c("cargo-input", {
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm.notifyEori,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "notifyEori",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.notifyEori"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "SeaExport.StreetNumber"
                                          )
                                        }
                                      },
                                      [
                                        _c("cargo-input", {
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .notifyStreetNo,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "notifyStreetNo",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.notifyStreetNo"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "VIP CODE" } },
                                      [
                                        _c("cargo-input", {
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .notifyVipCode,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "notifyVipCode",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.notifyVipCode"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "MSC CODE" } },
                                      [
                                        _c("cargo-input", {
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .notifyMscCode,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "notifyMscCode",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.notifyMscCode"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "COMPANY CODE" } },
                                      [
                                        _c("cargo-input", {
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .notifyCompanyCode,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "notifyCompanyCode",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.notifyCompanyCode"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "INTTRA CODE" } },
                                      [
                                        _c("cargo-input", {
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .notifyInttraCode,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "notifyInttraCode",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.notifyInttraCode"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "el-form-item-wrapper" },
                                  [
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("cargo-input", {
                                          staticClass: "input-w",
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          nativeOn: {
                                            dblclick: function($event) {
                                              return _vm.popRowDataEditor(
                                                "notify"
                                              )
                                            }
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .notifyLine1,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "notifyLine1",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.notifyLine1"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("cargo-input", {
                                          staticClass: "input-w",
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          nativeOn: {
                                            dblclick: function($event) {
                                              return _vm.popRowDataEditor(
                                                "notify"
                                              )
                                            }
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .notifyLine2,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "notifyLine2",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.notifyLine2"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("cargo-input", {
                                          staticClass: "input-w",
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          nativeOn: {
                                            dblclick: function($event) {
                                              return _vm.popRowDataEditor(
                                                "notify"
                                              )
                                            }
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .notifyLine3,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "notifyLine3",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.notifyLine3"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("cargo-input", {
                                          staticClass: "input-w",
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          nativeOn: {
                                            dblclick: function($event) {
                                              return _vm.popRowDataEditor(
                                                "notify"
                                              )
                                            }
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .notifyLine4,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "notifyLine4",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.notifyLine4"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("cargo-input", {
                                          staticClass: "input-w",
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          nativeOn: {
                                            dblclick: function($event) {
                                              return _vm.popRowDataEditor(
                                                "notify"
                                              )
                                            }
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .notifyLine5,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "notifyLine5",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.notifyLine5"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("cargo-input", {
                                          staticClass: "input-w",
                                          attrs: {
                                            "auto-uppercase":
                                              _vm.notUppercaseShipperConsigneNotify
                                          },
                                          nativeOn: {
                                            dblclick: function($event) {
                                              return _vm.popRowDataEditor(
                                                "notify"
                                              )
                                            }
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .notifyLine6,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "notifyLine6",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.notifyLine6"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-tag",
                              {
                                staticClass: "tag-w",
                                attrs: { size: "medium" }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("CargoMsg.Cargo_Payment1"))
                                )
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "el-form-item-wrapper el-form-item-group"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !_vm.formatManifestInfo,
                                        expression: "!formatManifestInfo"
                                      }
                                    ],
                                    style: {
                                      position: "relative",
                                      height: _vm.$selectByLang(
                                        "750px",
                                        "750px",
                                        "750px",
                                        "950px",
                                        "1000px",
                                        "950px"
                                      )
                                    }
                                  },
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: " " } },
                                      [
                                        _c("el-checkbox", {
                                          attrs: {
                                            label: _vm.$t(
                                              "baseInfo.mailingAddress.instructBill"
                                            )
                                          },
                                          on: { change: _vm.ladingPaymentBill },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .paymentInstructBill,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "paymentInstructBill",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.paymentInstructBill"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("line-label", {
                                          attrs: {
                                            slot: "label",
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_PaymentEnterpriseCode"
                                            )
                                          },
                                          slot: "label"
                                        }),
                                        _c("el-input", {
                                          directives: [
                                            {
                                              name: "uppercase",
                                              rawName: "v-uppercase"
                                            }
                                          ],
                                          attrs: {
                                            placeholder: _vm.$t(
                                              "baseInfo.mailingAddress.shortCode"
                                            )
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .paymentShortCode,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "paymentShortCode",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.paymentShortCode"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: " " } },
                                      [
                                        _c("el-input", {
                                          directives: [
                                            {
                                              name: "uppercase",
                                              rawName: "v-uppercase"
                                            }
                                          ],
                                          staticClass: "prefix-input",
                                          attrs: {
                                            placeholder: _vm.$t(
                                              "CargoMsg.Cargo_PaymentEnterpriseCode"
                                            )
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .paymentEnterpriseCode,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "paymentEnterpriseCode",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.paymentEnterpriseCode"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("line-label", {
                                          attrs: {
                                            slot: "label",
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_Payment2"
                                            )
                                          },
                                          slot: "label"
                                        }),
                                        _c("el-input", {
                                          directives: [
                                            {
                                              name: "uppercase",
                                              rawName: "v-uppercase"
                                            }
                                          ],
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .paymentEnterpriseName,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "paymentEnterpriseName",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.paymentEnterpriseName"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "CargoMsg.Cargo_Payment3"
                                          )
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          directives: [
                                            {
                                              name: "uppercase",
                                              rawName: "v-uppercase"
                                            }
                                          ],
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .paymentAddress,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "paymentAddress",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.paymentAddress"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            staticStyle: { width: "130px" },
                                            model: {
                                              value:
                                                _vm.mailingAddressForm
                                                  .paymentContactsType,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.mailingAddressForm,
                                                  "paymentContactsType",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "mailingAddressForm.paymentContactsType"
                                            }
                                          },
                                          _vm._l(
                                            _vm.contactType
                                              .paymentContactsTypes,
                                            function(item) {
                                              return _c("el-option", {
                                                key: item.value,
                                                attrs: {
                                                  label: item.label,
                                                  value: item.value
                                                }
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                        _c("el-input", {
                                          directives: [
                                            {
                                              name: "uppercase",
                                              rawName: "v-uppercase"
                                            }
                                          ],
                                          staticStyle: { width: "135px" },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .paymentContacts,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "paymentContacts",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.paymentContacts"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "baseInfo.mailingAddress.cityName"
                                          )
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          directives: [
                                            {
                                              name: "uppercase",
                                              rawName: "v-uppercase"
                                            }
                                          ],
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .paymentCityName,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "paymentCityName",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.paymentCityName"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "baseInfo.mailingAddress.provinceCode"
                                          )
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          directives: [
                                            {
                                              name: "uppercase",
                                              rawName: "v-uppercase"
                                            }
                                          ],
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .paymentProvinceCode,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "paymentProvinceCode",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.paymentProvinceCode"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "baseInfo.mailingAddress.provinceName"
                                          )
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          directives: [
                                            {
                                              name: "uppercase",
                                              rawName: "v-uppercase"
                                            }
                                          ],
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .paymentProvinceName,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "paymentProvinceName",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.paymentProvinceName"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "baseInfo.mailingAddress.zipCode"
                                          )
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          directives: [
                                            {
                                              name: "uppercase",
                                              rawName: "v-uppercase"
                                            }
                                          ],
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .paymentZipCode,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "paymentZipCode",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.paymentZipCode"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "CargoMsg.Cargo_CountryRegionCode"
                                          )
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          directives: [
                                            {
                                              name: "uppercase",
                                              rawName: "v-uppercase"
                                            }
                                          ],
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .paymentCountryCode,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "paymentCountryCode",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.paymentCountryCode"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "baseInfo.mailingAddress.aeoEnterpriseCode"
                                          )
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          directives: [
                                            {
                                              name: "uppercase",
                                              rawName: "v-uppercase"
                                            }
                                          ],
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .paymentAeoEnterpriseCode,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "paymentAeoEnterpriseCode",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.paymentAeoEnterpriseCode"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("line-label", {
                                          attrs: {
                                            slot: "label",
                                            label: _vm.$t(
                                              "baseInfo.mailingAddress.consigneeSpecificContactsName"
                                            )
                                          },
                                          slot: "label"
                                        }),
                                        _c("el-input", {
                                          directives: [
                                            {
                                              name: "uppercase",
                                              rawName: "v-uppercase"
                                            }
                                          ],
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .paymentSpecificContactsName,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "paymentSpecificContactsName",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.paymentSpecificContactsName"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "EORI" } },
                                      [
                                        _c("el-input", {
                                          directives: [
                                            {
                                              name: "uppercase",
                                              rawName: "v-uppercase"
                                            }
                                          ],
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .paymentEori,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "paymentEori",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.paymentEori"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "SeaExport.StreetNumber"
                                          )
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          directives: [
                                            {
                                              name: "uppercase",
                                              rawName: "v-uppercase"
                                            }
                                          ],
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .paymentStreetNo,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "paymentStreetNo",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.paymentStreetNo"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "VIP CODE" } },
                                      [
                                        _c("cargo-input", {
                                          directives: [
                                            {
                                              name: "uppercase",
                                              rawName: "v-uppercase"
                                            }
                                          ],
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .paymentVipCode,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "paymentVipCode",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.paymentVipCode"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "MSC CODE" } },
                                      [
                                        _c("cargo-input", {
                                          directives: [
                                            {
                                              name: "uppercase",
                                              rawName: "v-uppercase"
                                            }
                                          ],
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .paymentMscCode,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "paymentMscCode",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.paymentMscCode"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "COMPANY CODE" } },
                                      [
                                        _c("cargo-input", {
                                          directives: [
                                            {
                                              name: "uppercase",
                                              rawName: "v-uppercase"
                                            }
                                          ],
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .paymentCompanyCode,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "paymentCompanyCode",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.paymentCompanyCode"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "INTTRA CODE" } },
                                      [
                                        _c("cargo-input", {
                                          directives: [
                                            {
                                              name: "uppercase",
                                              rawName: "v-uppercase"
                                            }
                                          ],
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .paymentInttraCode,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "paymentInttraCode",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.paymentInttraCode"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            staticStyle: { width: "130px" },
                                            model: {
                                              value:
                                                _vm.mailingAddressForm
                                                  .paymentSpecificContactsType,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.mailingAddressForm,
                                                  "paymentSpecificContactsType",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "mailingAddressForm.paymentSpecificContactsType"
                                            }
                                          },
                                          _vm._l(
                                            _vm.contactType
                                              .paymentSpecificContactsTypes,
                                            function(item) {
                                              return _c("el-option", {
                                                key: item.value,
                                                attrs: {
                                                  label: item.label,
                                                  value: item.value
                                                }
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                        _c("el-input", {
                                          directives: [
                                            {
                                              name: "uppercase",
                                              rawName: "v-uppercase"
                                            }
                                          ],
                                          staticStyle: { width: "135px" },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .paymentSpecificContacts,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "paymentSpecificContacts",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.paymentSpecificContacts"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "float-btn-wrapper" },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: { type: "info" },
                                            on: {
                                              click: function($event) {
                                                return _vm.syncFormatInfoToOrder(
                                                  "payment"
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "baseInfo.mailingAddress.syncFormatInfoToOrder"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "el-form-item-wrapper" },
                                  [
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("el-input", {
                                          directives: [
                                            {
                                              name: "uppercase",
                                              rawName: "v-uppercase"
                                            }
                                          ],
                                          staticClass: "input-w",
                                          nativeOn: {
                                            dblclick: function($event) {
                                              return _vm.popRowDataEditor(
                                                "payment"
                                              )
                                            }
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .paymentLine1,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "paymentLine1",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.paymentLine1"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("el-input", {
                                          directives: [
                                            {
                                              name: "uppercase",
                                              rawName: "v-uppercase"
                                            }
                                          ],
                                          staticClass: "input-w",
                                          nativeOn: {
                                            dblclick: function($event) {
                                              return _vm.popRowDataEditor(
                                                "payment"
                                              )
                                            }
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .paymentLine2,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "paymentLine2",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.paymentLine2"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("el-input", {
                                          directives: [
                                            {
                                              name: "uppercase",
                                              rawName: "v-uppercase"
                                            }
                                          ],
                                          staticClass: "input-w",
                                          nativeOn: {
                                            dblclick: function($event) {
                                              return _vm.popRowDataEditor(
                                                "payment"
                                              )
                                            }
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .paymentLine3,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "paymentLine3",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.paymentLine3"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("el-input", {
                                          directives: [
                                            {
                                              name: "uppercase",
                                              rawName: "v-uppercase"
                                            }
                                          ],
                                          staticClass: "input-w",
                                          nativeOn: {
                                            dblclick: function($event) {
                                              return _vm.popRowDataEditor(
                                                "payment"
                                              )
                                            }
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .paymentLine4,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "paymentLine4",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.paymentLine4"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("el-input", {
                                          directives: [
                                            {
                                              name: "uppercase",
                                              rawName: "v-uppercase"
                                            }
                                          ],
                                          staticClass: "input-w",
                                          nativeOn: {
                                            dblclick: function($event) {
                                              return _vm.popRowDataEditor(
                                                "payment"
                                              )
                                            }
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .paymentLine5,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "paymentLine5",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.paymentLine5"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("el-input", {
                                          directives: [
                                            {
                                              name: "uppercase",
                                              rawName: "v-uppercase"
                                            }
                                          ],
                                          staticClass: "input-w",
                                          nativeOn: {
                                            dblclick: function($event) {
                                              return _vm.popRowDataEditor(
                                                "payment"
                                              )
                                            }
                                          },
                                          model: {
                                            value:
                                              _vm.mailingAddressForm
                                                .paymentLine6,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.mailingAddressForm,
                                                "paymentLine6",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "mailingAddressForm.paymentLine6"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.submitMailingAddress }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
              ),
              _c("el-button", { on: { click: _vm.handleCancel } }, [
                _vm._v(_vm._s(_vm.$t("common.btn.cancel")))
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }